module.exports = __webpack_public_path__ + "static/media/iconFilter2.e9999e66.svg";